var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"guides-expired","route":"/reports/billing-guides-expired","file-name":"guias-fora-do-prazo.xlsx","period-label":"Período do atendimento","columns":_vm.columns,"default-days":360}})
}
var staticRenderFns = []

export { render, staticRenderFns }